const WORKSHOP_CARDS = [
  {
    badge: "Upcoming",
    title: "Vibe Coding from Zero",
    description:
      "Build a real working app in 90 minutes. No code experience needed for this workshop.",
  },
  {
    badge: "This weekend",
    title: "Claude Skills Masterclass",
    description:
      "Build 3 practical Skills live. Leave with tools you'll use every day and use them in your Workflow.",
  },
  {
    badge: "Concluded",
    title: "AI Agents: Build your first in 2 hours",
    description:
      "N8N + Claude. Recorded session, available to community members.",
  },
  {
    badge: "Concluded",
    title: "The Prompt Engineering Deep Dive",
    description:
      "The PRD method, the Magic Prompt Formula, and live Q&A with Vaibhav.",
  },
] as const;

const CARD_GRADIENT = "linear-gradient(145deg, #22021F 0%, #000000 100%)";

// function scrollToResourceCta(): void {
//   document.getElementById("homepage-cta")?.scrollIntoView({
//     behavior: "smooth",
//     block: "start",
//   });
//   setTimeout(() => {
//     const input = document.getElementById("footer-cta-email") as HTMLInputElement | null;
//     if (!input) return;
//     input.focus();
//     input.style.outline = "2px solid rgba(255,255,255,0.75)";
//     input.style.outlineOffset = "2px";
//     setTimeout(() => {
//       input.style.outline = "";
//       input.style.outlineOffset = "";
//     }, 1200);
//   }, 700);
// }

export default function LiveWorkshops() {
  return (
    <section
      className="w-full bg-black py-8 md:py-14 font-fira text-white sm:py-20"
      aria-label="Live workshops"
    >
      <div className="mx-auto flex w-[90%] flex-col gap-6 md:w-[80%] md:flex-row md:items-stretch md:gap-6 lg:gap-8">
        {/* Left — 60%; mobile: copy over image; desktop: matches right column height */}
        <div className="flex w-full shrink-0 flex-col md:h-full md:min-h-0 md:w-[60%] md:max-w-[60%]">
          {/* Mobile — single card: text overlaid on workshopm.webp */}
          <div className="relative isolate min-h-[680px] overflow-hidden rounded-xl border border-[#FFFFFF66] md:hidden">
            <img
              src="/resources/workshopm.webp"
              alt=""
              className="absolute inset-0 h-full w-full object-cover"
              loading="lazy"
              decoding="async"
            />
          
            <div className="relative z-10 flex flex-col gap-4 px-5 py-6">
              <p className="font-fira text-sm font-normal uppercase tracking-[0.18em] text-[#FFFFFF]">
                Live workshops
              </p>
              <h2 className="font-fira-condensed text-[30px] font-medium md:font-semibold leading-tight text-white md:text-[42px]">
                Every week. Live sessions on AI. Free for members
              </h2>
              <p className="font-fira text-sm leading-relaxed text-[#FFFFFF85] md:text-base">
                Live workshops every week on what's actually working in AI. Past sessions have covered prompt engineering, building AI agents, Claude Skills, and vibe coding from scratch.
              </p>
              {/* <button
                type="button"
                onClick={scrollToResourceCta}
                className="w-fit rounded-lg border border-white/25 bg-transparent px-5 py-3 text-sm font-medium text-white transition hover:bg-white/5"
              >
                Join to get Workshop Updates
              </button> */}
            </div>
          </div>

          {/* Desktop — fills stretched column (same height as right stack) */}
          <div className="relative hidden min-h-[620px] flex-1 overflow-hidden rounded-xl border border-[#FFFFFF66] md:flex md:flex-col">
            <img
              src="/resources/workshopd.webp"
              alt=""
              className="absolute inset-0 h-full w-full object-cover "
              loading="lazy"
              decoding="async"
            />

            <div className="relative z-10 flex min-h-0 flex-1 flex-col items-start justify-start gap-5 p-8 lg:p-10">
              <p className="font-fira text-sm font-normal uppercase tracking-[0.18em] text-[#FFFFFF]">
                Live workshops
              </p>
              <h2 className="font-fira-condensed text-[30px] font-medium md:font-semibold leading-tight text-white md:text-[42px]">
               Every week. Live sessions on AI. Free for members
              </h2>
              <p className="font-fira text-sm leading-relaxed text-[#FFFFFF85] md:text-base">
                Live workshops every week on what's actually working in AI. Past sessions have covered prompt engineering, building AI agents, Claude Skills, and vibe coding from scratch.
              </p>
              {/* <button
                type="button"
                onClick={scrollToResourceCta}
                className="mt-2 w-fit rounded-lg border border-white/25 bg-transparent px-5 py-3 text-sm font-medium text-white transition hover:bg-white/5"
              >
                Join to get Workshop Updates
              </button> */}
            </div>
          </div>
        </div>

        {/* Right — 40%; hidden on mobile */}
        <div className="relative hidden w-full md:flex md:h-full md:min-h-0 md:w-[40%] md:max-w-[40%] md:flex-col">
          <div className="flex flex-col gap-3">
            {WORKSHOP_CARDS.map((card, idx) => (
              <div
                key={card.title}
                className="relative overflow-hidden rounded-xl border border-[#FFFFFF33] p-4 lg:p-5"
                style={{ background: CARD_GRADIENT }}
              >
                {idx >= 2 ? (
                  <div
                    className={`pointer-events-none absolute inset-0 z-[1] rounded-[inherit] ${
                      idx === 2
                        ? "bg-gradient-to-b from-transparent via-black/50 to-black/95"
                        : "bg-gradient-to-b from-black/25 via-black/70 to-black"
                    }`}
                    aria-hidden
                  />
                ) : null}
                <div className="font-fira relative z-[2] flex flex-col gap-2">
                  <span className="w-fit rounded-full bg-[#08090A85] border border-[#FFFFFF3D] px-2.5 py-0.5 text-[10px] font-normal uppercase tracking-wider text-[#FFFFFFE5]">
                    {card.badge}
                  </span>
                  <h3 className=" text-[18px] font-medium leading-snug text-white lg:text-lg">
                    {card.title}
                  </h3>
                  <p className="text-sm leading-relaxed text-[#CFCFCFE5] font-normal">
                    {card.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
          <div
            className="pointer-events-none absolute bottom-0 left-0 right-0 z-[3] h-24 bg-gradient-to-b from-transparent to-black"
            aria-hidden
          />
        </div>
      </div>
    </section>
  );
}
